const React = require("react");
const withState = require("../../../../../../utils/withState");

import NewPaymentLinkForm from './components/NewPaymentLinkForm';
import fetchDefaultData from './utils/fetchDefaultData';

module.exports = withState((setState, self, onMount) => {
  const paramsId = ((self.props || {}).params || {}).id;
  const id = !!paramsId && paramsId !== 'create' ? paramsId : ''

  self.state = {
    ...self.state,
    loading: true
  }

  onMount(() => {
    fetchDefaultData({id})
        .then((nextState) => setState(nextState))
        .finally(() => setState({loading: false}));
  })


  return (state) => {
    const {
      customersList,
      assetsList,
      assetsLimits,
      defaultData,
      loading
    } = state;

    return loading
      ? (
        <span />
      ) : (
        <NewPaymentLinkForm
          id={id}

          customersList={customersList}
          assetsList={assetsList}
          assetsLimits={assetsLimits}
          defaultData={defaultData}
        />
      )
  }
})
